export default function DictionaryResultCN({
  html, 
  error,
  loading,
  mealPlanHtml, 
  onMealPlan, 
  mealPlanLoading,
  mealPlanError,
  showMealPlanButton = true,
}) {
  return (
    <div className="dictionary-result">
      {loading ? (
        <p>分析中... 稍微等一下。</p>
      ) : error ? (
        <p className="error">{error}</p>
      ) : html ? (
        <div className="answer">
          <div dangerouslySetInnerHTML={{ __html: html }} />
        </div>
      ) : (
        <p></p>
      )}

      {/* 보조 기능: 식단 추천 */}
      {!!html && showMealPlanButton && (
        <div className="dictionary-feature">
          <button className="btn" onClick={onMealPlan} disabled={mealPlanLoading}>
            接受一天食谱推荐
          </button>

          {mealPlanLoading && <p>创建中... 请稍等。</p>}
          {mealPlanError && <p className="error">{mealPlanError}</p>}
          {mealPlanHtml && <div className="mealplan-result" dangerouslySetInnerHTML={{ __html: mealPlanHtml }} />}
        </div>
      )}
    </div>
  );
}
